import { useMemo } from 'react';
import { useGetBuildingPackageResultsQuery } from '../api';
export const useBuildingPackageResults = (params) => {
    const { data: resultsResponse, isLoading, isFetching, isError, error, } = useGetBuildingPackageResultsQuery(params);
    return useMemo(() => {
        const totalCount = resultsResponse?.count || 0;
        const results = resultsResponse?.results || [];
        const next = resultsResponse?.next;
        const previous = resultsResponse?.previous;
        return {
            results,
            totalCount,
            next,
            previous,
            isLoading,
            isFetching,
            isError,
            error,
        };
    }, [resultsResponse, isLoading, isFetching, isError, error]);
};
